import { toast } from "react-toastify";

function showSuccessToast(text) {
  try {
    toast.dismiss();
    toast.success(text, {
      autoClose: 1200,
      pauseOnHover: false,
      closeOnClick: true,
    });
  } catch (error) {
    console.log("showSuccessToast Error: ", error);
  }
}

export function treateReasonToCopy(reason) {
  try {
    const hasReason = Boolean(reason) && typeof reason === "string";
    if (!hasReason) return reason;
    const formatedReason = reason.replace(/^[^:]*:\s*/, "");
    return formatedReason;
  } catch (error) {
    return reason;
  }
}

export async function handleCopy(value) {
  try {
    await navigator.clipboard.writeText(value);

    // showSuccessToast("Texto copiado com sucesso.");
    return true;
  } catch (error) {
    toast.error("Ocorreu um erro ao copiar o texto.");
    return false;
  }
}
